<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading
        :active.sync="isLoading"
        loader="spinner"
        color="#36304a"
        :width="70"
      ></loading> -->
    </div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar class="formCard" style="border-radius: 5px !important; padding-left: 0px" toggleable="lg" type="dark"
          variant="primary">
          <b-navbar-nav>
            <b-button @click="goBack" size="sm" variant="light">
              <md-icon icon="gear-fill" aria-hidden="true">skip_previous</md-icon>Back
            </b-button>
          </b-navbar-nav>
          <b-navbar-brand center>{{ $route.name }} </b-navbar-brand>
          <b-navbar-nav class="ml-auto">
            <b-nav-form> </b-nav-form>
          </b-navbar-nav>
        </b-navbar>

        <b-card class="formCard">
          <b-card-text>
            <b-row class="mt-4 mb-2">
              <b-col md="3" class="ml-4" style="border-right: 0.5px solid lightgray">
                <div>
                  <h6 class="greyText" style="font-size: 15px"><b>SUBSCRIPTION</b></h6>
                  <i class="fa fa-envelope mr-2 mainColorText" style="font-size: 26px"></i><span class="mainColorText"
                    style="font-size: 26px"><b>{{ getSingleSubscriptions.id }}</b></span><br />
                  <span>{{ getSingleSubscriptions.request_carrier_name }}</span>
                  <b-row class="ml-1">
                    <b-col v-b-tooltip.bottomright title="Creates a secret link to this container that can be shared with others.
                        Anybody who knows this link will be able to view this container status page without having to log in. 
                        Internal details such as description and tags will NOT be shown"
                      class="pl-2 py-1 mr-1 mainColorBackground" style="max-width: 48%; border-radius: 5px">
                      <i class="fa fa-share mr-2 white"></i>
                      <i class="white">Share this subscription</i>
                    </b-col>
                    <i class="fa fa-info-circle mt-2" style="font-size: 15px"></i>
                  </b-row>

                  <!-- on click of share subscription open the below b-col-->
                  <!-- <b-row class="ml-1">
                    <b-col style="max-width: 48%; border-radius: 5px;" class="pl-2 mr-1 mainColorBackground">
                      <i class="fa fa-eraser mr-2 white"></i>
                      <i class="white"> Revoke Sharing </i>
                    </b-col>
                    <i class="fa fa-envelope mt-1 mainColorText" style="font-size: 13px;" v-b-tooltip.bottomright title="Mailed shared link"></i>
                    <i class="fa fa-clipboard mt-1 ml-1 mainColorText" style="font-size: 13px;" v-b-tooltip.bottomright title="Copy shared link to clipboard"></i>
                  </b-row> -->
                </div>
              </b-col>

              <b-col md="3" class="ml-4">
                <h6 class="greyText" style="font-size: 13px">
                  <b>DESCRIPTION & TAGS</b>
                </h6>
                <p>
                  <i class="fa fa-file-text mt-2 greyText" style="font-size: 20px"></i>
                </p>
                <p>
                  <i class="fa fa-tag greyText" style="font-size: 20px" v-b-tooltip.bottomright title="Tags"></i>
                </p>
              </b-col>
            </b-row>

            <b-row class="mt-5 ml-4 mr-4 pl-2 py-3 listingTitle">
              <md-layout md-flex="100">
                <i class="fa fa-envelope pl-2 mr-2 greyText" style="font-size: 18px"></i>
                <span style="font-size: 18px"><b>Subscription Details</b></span>
              </md-layout>
            </b-row>

            <b-row class="ml-4 mr-4 pl-2 py-3 listingBody">
              <md-layout>
                <md-layout md-flex="100">
                  <span><b>Carrier ref. # </b>
                    <i v-b-tooltip.bottomright title="Carrier, request type and subscription ref. #"
                      class="fa fa-info-circle mt-2" style="font-size: 15px"></i>
                    {{ getSingleSubscriptions.request_carrier_name }} - Booking number
                    {{ getSingleSubscriptions.request_key }}
                  </span>
                </md-layout>
              </md-layout>

              <md-layout>
                <md-layout md-flex="100">
                  <span><b>Description : {{ getSingleSubscriptions.descriptive_name }}</b></span>
                </md-layout>
              </md-layout>

              <md-layout>
                <md-layout md-flex="100">
                  <span><b>Sub-account : {{ getSingleSubscriptions.account_name }}</b></span>
                </md-layout>
              </md-layout>
            </b-row>

            <b-row class="ml-4 mr-4 pl-2 py-3 listingBody">
              <md-layout>
                <md-layout md-flex="100">
                  <span><b>Tags : </b></span>
                </md-layout>
              </md-layout>

              <md-layout>
                <md-layout md-flex="100">
                  <span><b>Contractual ETD @ POL :
                      <span v-if="getSingleSubscriptions.contractual_etd_pol">{{
                        getSingleSubscriptions.contractual_etd_pol | moment
                        }}</span></b></span>
                </md-layout>
              </md-layout>

              <md-layout>
                <md-layout md-flex="100">
                  <span><b>Contractual ETA @ POD :<span v-if="getSingleSubscriptions.contractual_eta_pod">{{
                        getSingleSubscriptions.contractual_eta_pod | moment }}</span>
                    </b></span>
                </md-layout>
              </md-layout>
            </b-row>

            <b-row class="ml-4 mr-4 pl-2 py-3 listingBody">
              <md-layout>
                <md-layout md-flex="100">
                  <span><b>Contractual ETA @ DLV :
                      <span v-if="getSingleSubscriptions.contractual_eta_dlv">{{
                        getSingleSubscriptions.contractual_eta_dlv | moment
                        }}</span></b></span>
                </md-layout>
              </md-layout>

              <md-layout>
                <md-layout md-flex="100">
                  <b>Subscription Status :
                    <span v-if="getSingleSubscriptions.status_verbose">{{
                      getSingleSubscriptions.status_verbose
                      }}</span></b>
                </md-layout>
              </md-layout>

              <md-layout>
                <md-layout md-flex="100">
                  <b>Last update : </b>
                  <span v-if="getSingleSubscriptions.last_carrier_update">{{
                    getSingleSubscriptions.last_carrier_update | moment
                    }}</span>
                </md-layout>
              </md-layout>
            </b-row>

            <b-row class="ml-4 mr-4 pl-2 py-3 listingBody">
              <md-layout>
                <md-layout md-flex="100">
                  <span><b>Submitted : </b></span>
                  <span v-if="getSingleSubscriptions.created">{{
                    getSingleSubscriptions.created | moment
                    }}</span>
                </md-layout>
              </md-layout>
            </b-row>

            <b-row class="mt-5 ml-4 mr-4 pb-3 listingBody">
              <md-layout class="listingTitle py-3 pl-2" md-flex="100">
                <i class="fa fa-cube pl-2 mr-2 greyText" style="font-size: 18px"></i>
                <span style="font-size: 18px"><b>Container list: one container in shipment subscription</b></span>
              </md-layout>

              <md-layout class="listingBody py-3 pl-3 pr-3 pb-5" md-flex="100">
                <div class="table-responsive tableMain">
                  <b-table show-empty stacked="md" responsive :items="getSingleSubscriptions.containershipments"
                    :fields="containerFields" primary-key="container_number">
                    <template slot="SN" slot-scope="row0">
                      <span>{{
                        row0.index + 1 + (pagination.currentPage - 1) * pagination.perPage
                        }}</span>
                    </template>

                    <template slot="container" slot-scope="row1">
                      <span @click="getShipmentSubscription(row1.item)" style="color: blue"><i
                          class="fa fa-cube pl-2 mr-2" style="color: #007bff; font-size: 13px"></i>
                        <u>{{ row1.item.container_number }}</u><br /></span>
                      <span v-if="row1.item.container_type_str">{{"Cont. Type :"+row1.item.container_type_str}}<br /></span>
                      <span v-if="row1.item.shipmentsubscription_id">{{"Subs. ID :"+row1.item.shipmentsubscription_id}}<br /></span>
                      <span v-if="row1.item.lifecycle_status_verbose">{{"Lifecycle Status : "+row1.item.lifecycle_status_verbose}}<br /></span>
                      <span v-if="row1.item.lifecycle_status_verbose">{{"Lifecycle Status :"+row1.item.lifecycle_status_verbose}}<br /></span>
                      <span v-if="row1.item.booking_number">{{"Booking No. : "+row1.item.booking_number}}<br /></span>
                      <span v-if="row1.item.leg1_service">{{"Vessel voyage. :"+row1.item.leg1_service.name}}<br /></span>
                      <span v-if="row1.item.leg1_voyage">{{"Voyage No. : "+row1.item.leg1_voyage}}<br /></span>
                    </template>

                    <template slot="type" slot-scope="row2">
                      <span>{{ row2.item.container_type_iso }}</span>
                      <p>
                        <i class="fa fa-file-text mt-2 greyText" style="font-size: 13px"></i>
                      </p>
                    </template>

                    <template slot="ORI/POL" slot-scope="row3">
                      <span v-if="row3.item.origin_loc">{{ "ORI Name : " + row3.item.origin_loc.name }}<br /></span>
                      <span v-if="row3.item.origin_loc">{{ "ORI Code : " + row3.item.origin_loc.locode }}<br /></span>
                      <span v-if="row3.item.pol_loc">{{ "POL Name : " + row3.item.pol_loc.name }}<br /></span>
                      <span v-if="row3.item.pol_loc">{{ "POL Code : " + row3.item.pol_loc.locode }}<br /></span>
                      <p>
                        <i class="fa fa-tag greyText" style="font-size: 13px" v-b-tooltip.bottomright title="Tags"></i>
                      </p>
                    </template>

                    <template slot="POD/DLV" slot-scope="row4">
                      <span v-if="row4.item.pod_loc">{{ "POD Name : " + row4.item.pod_loc.name }}<br /></span>
                      <span v-if="row4.item.pod_loc">{{ "POD Code : " + row4.item.pod_loc.locode }}<br /></span>
                      <span v-if="row4.item.dlv_loc">{{ "DLV Name : " + row4.item.dlv_loc.name }}<br /></span>
                      <span v-if="row4.item.dlv_loc">{{ "DLV Code : " + row4.item.dlv_loc.locode }}<br /></span>
                    </template>

                    <template slot="ETA/ATA" slot-scope="row4">
                      <span>{{ "ETA Estimated" }}
                        <b v-if="row4.item.pod_vslarrival_planned_initial">{{
                          row4.item.pod_vslarrival_planned_initial | moment
                          }}</b><br /></span>
                      <span>{{ "ETA ACtual" }}
                        <b v-if="row4.item.pod_vslarrival_detected">{{
                          row4.item.pod_vslarrival_detected | moment
                          }}</b><br /></span>
                    </template>

                    <template slot="transportStatus" slot-scope="row5">
                      {{ row5.item.shipmentsubscription_status_verbose }}
                    </template>

                    <template slot="status" slot-scope="row6">
                      {{ row6.item.status_verbose }}
                      <p>
                        <i class="fa fa-eye" style="font-size: 13px" v-b-tooltip.bottomright
                          :title="'Container is actively monitored '+row6.item.status_verbose"></i>
                      </p>
                    </template>
                  </b-table>
                </div>
              </md-layout>
            </b-row>
          </b-card-text>
        </b-card>
      </b-card-text>
    </b-card>

    <md-dialog-alert :md-content="alert.content" :md-ok-text="alert.ok" ref="addPop"></md-dialog-alert>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import { ModelListSelect } from "vue-search-select";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat } from "../../helper/filters";
import { globalPermissionStatus } from "../../helper/collection";
import OceanInsightsSubscriptionService from "../../services/OceanInsightsSubscriptionService.js";
import moment from "moment";
import CustomLoader from "../common/customLoader.vue";
export default {
  beforeMount() {
    if (globalPermissionStatus("Dashboard_Access")) {
      this.$store.dispatch(
        "setCurrentRoute",
        "/tracking/ocean-insights/affectedCont/" + this.$route.params.subscription_id
      );
      this.getSingleSubscriptionsFunc();
    } else {
      this.$router.push({
        path: "/dashboard",
      });
    }
  },
  data() {
    return {
      ExcelBtnName: "Export As Excel",
      totalRows: 0,
      currentPage: 1,
      perPage: 1000,
      pageOptions: [20, 50, 100],
      sortBy: null,
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      getSingleSubscriptions: {},
      pagination: {
        currentPage: 1,
        perPage: 25,
        pageOptions: [5, 10, 15],
      },

      containerFields: [
        {
          key: "SN",
          mainkey: "SN",
          label: "SN.",
          sortable: true,
          sortDirection: "ASC",
          table: "A.",
        },
        {
          key: "container",
          mainkey: "container",
          label: "Container",
          sortable: true,
          sortDirection: "ASC",
          table: "B.",
        },
        {
          key: "type",
          mainkey: "type",
          label: "Type",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
        {
          key: "ORI/POL",
          mainkey: "ORI/POL",
          label: "ORI/POL",
          sortable: true,
          sortDirection: "ASC",
          table: "D.",
        },
        {
          key: "POD/DLV",
          mainkey: "POD/DLV",
          label: "POD/DLV",
          sortable: true,
          sortDirection: "ASC",
          table: "F.",
        },
        {
          key: "ETA/ATA",
          mainkey: "ETA/ATA",
          label: "ETA/ATA",
          sortable: true,
          sortDirection: "ASC",
          table: "G.",
        },
        {
          key: "transportStatus",
          mainkey: "transportStatus",
          label: "Transport status	",
          sortable: true,
          sortDirection: "ASC",
          table: "H.",
        },
        {
          key: "status",
          mainkey: "status",
          label: "Status",
          sortable: true,
          sortDirection: "ASC",
          table: "I.",
        },
      ],

      docURL: URL_BASE_DOC,
      alert: {
        content: "Added Succesfully",
        ok: "ok",
      },
      lastVisitPage: this.$sessionsStorage.get("lastVisitPage"),
      isLoading: false,
      Filter: "",
    };
  },

  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },

  mounted() {},

  beforeDestroy() {},

  destroyed() {},

  components: {
    DatePicker,
    ModelListSelect,
    Loading,
    CustomLoader,
  },
  watch: {},

  computed: {
    podDischargePrediction(data) {
      return data;
    },
  },
  methods: {
    getShipmentSubscription(item) {
      this.$router.push({
        path: "/tracking/ocean-insights/shipment/" + item.id,
      });
    },
    daysDifference(created, predicted) {
      let daysDifference = 0;
      if (created && predicted) {
        const createdDate = new Date(created);
        const predictedDate = new Date(predicted);

        // Calculate the time difference in milliseconds
        const timeDifference = predictedDate - createdDate;

        // Convert the time difference to days
        daysDifference = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
      }
      return daysDifference;
    },
    async getSingleSubscriptionsFunc() {
      let payload = {};
      this.isLoading = true;
      this.getSingleSubscriptions = {};
      payload = {
        itemCode: "getSingleSubscriptions",
        subscription_id: this.$route.params.subscription_id,
      };

      payload = JSON.stringify(payload);

      OceanInsightsSubscriptionService.getAllOceanInsightList(payload)
        .then((response) => {
          const { data, status, statusText } = response;
          if (status == 200 && data) {
            this.isLoading = false;
            console.log("getSingleSubscriptions PS =>", data);

            if (data.getSingleSubscriptions) {
              this.getSingleSubscriptions = data.getSingleSubscriptions;
            }
            console.log("getSingleSubscriptions PS =>", this.getSingleSubscriptions);
          }
        })
        .catch((error) => {
          console.log("Catch on getSingleSubscriptions Error: ", error);
        });
    },

    goBack() {
      window.history.go(-1);
    },
  },
};
</script>

<style>
.white {
  color: white;
}
.mainColorText {
  color: #00558b;
}
.mainColorBackground {
  background-color: #00558b;
}
.greyText {
  color: grey;
}
.listingTitle {
  background-color: #e4e7eb;
  border-top: solid #00558b;
  border-radius: 5px;
  font-size: 20px;
}

.listingBody {
  background-color: #f5f7fa;
  border-top: 0.5px solid lightgrey;
  border-radius: 5px;
  font-size: 13px;
}

.b-tooltip.bottom .tooltip-inner {
  max-width: 60%;
}
</style>



// WEBPACK FOOTER //
// affectedSubscriptionCont.vue?4e27c1ad